import titleoverlay from './titleoverlay';
import airplayButton from './airplay-button';
import chromecast from './chromecast';
import watermark from './watermark';
import ima from './ima';
import share from './share';
import qualityselector from './quality-selector';
import kijwijzerPlugin from './kijkwijzer';

// You can add or remove plugins here
export default {
  titleoverlay,
  airplayButton,
  chromecast,
  watermark,
  ima,
  share,
  qualityselector,
  kijwijzerPlugin,
};
